/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ScholarshiptypeIdEnrollmentLinks200,
  GetApiV1ScholarshiptypeIdEnrollmentLinks401,
  GetApiV1ScholarshiptypeIdEnrollmentLinks404,
  GetApiV1ScholarshiptypeIdEnrollmentLinks500,
  GetApiV1ScholarshiptypeIdEnrollmentLinksPathParams,
  GetApiV1ScholarshiptypeIdEnrollmentLinksQueryResponse,
} from "../../types/scholarshipTypeLinksDeMatrculaController/GetApiV1ScholarshiptypeIdEnrollmentLinks.ts";
import { scholarshipTypeEnrollmentLinksViewModelSchema } from "../scholarshipTypeEnrollmentLinksViewModelSchema.ts";

export const getApiV1ScholarshiptypeIdEnrollmentLinksPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ScholarshiptypeIdEnrollmentLinksPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ScholarshiptypeIdEnrollmentLinks200Schema = z.lazy(
  () => scholarshipTypeEnrollmentLinksViewModelSchema,
) as unknown as ToZod<GetApiV1ScholarshiptypeIdEnrollmentLinks200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ScholarshiptypeIdEnrollmentLinks401Schema =
  z.any() as unknown as ToZod<GetApiV1ScholarshiptypeIdEnrollmentLinks401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ScholarshiptypeIdEnrollmentLinks404Schema =
  z.any() as unknown as ToZod<GetApiV1ScholarshiptypeIdEnrollmentLinks404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ScholarshiptypeIdEnrollmentLinks500Schema =
  z.any() as unknown as ToZod<GetApiV1ScholarshiptypeIdEnrollmentLinks500>;

export const getApiV1ScholarshiptypeIdEnrollmentLinksQueryResponseSchema =
  z.lazy(
    () => getApiV1ScholarshiptypeIdEnrollmentLinks200Schema,
  ) as unknown as ToZod<GetApiV1ScholarshiptypeIdEnrollmentLinksQueryResponse>;
